import GridLayout, { type Layout } from 'react-grid-layout'
import { useResizeDetector } from 'react-resize-detector'

import { useAppSelector } from 'app/hooks'

import {
  ISystemGraphsViewProps,
  QRAGraphType
} from 'features/RiskManagement/Components/Graphs'
import { GraphComponentById } from 'features/RiskManagement/Components/Graphs/graphComponentById'
import { selectSavedFilter } from 'features/RiskManagement/Components/LocalFilter/localFilterSelectors'

const GraphsView = ({
  qraViewBasePath,
  showLoading,
  charts = {},
  hasLineViewNavigation,
  itemsFromGraphType
}: ISystemGraphsViewProps) => {
  const ROW_1_H = 10
  const ROW_2_H = 8
  const ROW_3_H = 10
  const ROW_4_H = 7

  const ROW_3_Y = ROW_1_H + ROW_2_H
  const ROW_4_Y = ROW_3_Y + ROW_3_H

  // REVIEW: Persist positioning info as is to backend?
  const standardLayout: Layout[] = [
    { i: QRAGraphType.THREATS, x: 0, y: 0, w: 3, h: ROW_1_H, static: true },
    {
      i: QRAGraphType.CONSEQUENCES,
      x: 3,
      y: 0,
      w: 3,
      h: ROW_1_H,
      static: true
    },
    {
      i: QRAGraphType.RISK_BY_LINE,
      x: 0,
      y: ROW_1_H,
      w: 6,
      h: ROW_2_H,
      static: true
    },
    {
      i: QRAGraphType.RISK_FORECAST,
      x: 0,
      y: ROW_3_Y,
      w: 6,
      h: ROW_3_H,
      static: true
    },
    {
      i: QRAGraphType.RISK_BY_SIGNIFICANCE_LEVEL,
      x: 0,
      y: ROW_4_Y,
      w: 3,
      h: ROW_4_H,
      static: true
    },
    {
      i: QRAGraphType.RISK_BY_SYSTEM,
      x: 3,
      y: ROW_4_Y,
      w: 3,
      h: ROW_4_H,
      static: true
    }
  ]

  const localFilter = useAppSelector(selectSavedFilter)
  const { ref: targetRef, width } = useResizeDetector()

  return (
    <div ref={targetRef as React.RefObject<HTMLDivElement>}>
      {Boolean(width) && (
        <GridLayout
          layout={standardLayout}
          width={width}
          cols={6}
          margin={[20, 20]}
          rowHeight={25}
          className='relative'
        >
          {standardLayout.map(({ i }) => (
            <div key={i}>
              <GraphComponentById
                graphType={i}
                showLoading={showLoading}
                charts={charts}
                localFilter={localFilter}
                qraBasePath={
                  hasLineViewNavigation ? qraViewBasePath : undefined
                }
                itemsFromGraphType={itemsFromGraphType}
              />
            </div>
          ))}
        </GridLayout>
      )}
    </div>
  )
}

export default GraphsView
